import { LogoutModalTranslations } from "./types";

export const deTranslations: LogoutModalTranslations = {
    title: "Achtung!",
    gameSubtitle:
        "Bist du sicher? Wenn du das Spiel jetzt verlässt, kannst du nicht mehr zurückkehren.",
    subtitle: "Bist du sicher?",
    logoutText: "Abmelden",
    cancelText: "Abbrechen",
};
